{
  "label": "Tags",
  "add": "Add tag",
  "remove": "Remove",
  "search_or_create": "Search or create tag…",
  "empty": "No tags yet",
  "create_named": "Create \"{name}\"",
  "confirm_delete": "Delete the tag \"{name}\" for the whole team?",
  "error_generic": "Couldn't update tags.",
  "error_permission": "Only team admins can create or delete tags."
}
